import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ISelectOption } from 'src/app/models/selectOptions';

@Component({
  selector: 'app-filter-chips',
  templateUrl: './filter-chips.component.html',
  styleUrls: ['./filter-chips.component.scss'],
})
export class FilterChipsComponent {
  @Input() public options: ISelectOption[];
  @Output() public chipOnSelection = new EventEmitter<ISelectOption[]>();

  public onClickEvent(optionIndex: number) {
    if (this._getAllActiveChips().length == this.options.length) {
      // It means that currently all filters are on, so we want to disable all filters except the one that was picked.
      this.options.forEach((option) => {
        option.disabled = !option.disabled;
      });
    }
    this.options[optionIndex].disabled = !this.options[optionIndex].disabled;
    this.chipOnSelection.emit(this._getAllActiveChips());
  }

  private _getAllActiveChips(): ISelectOption[] {
    const activeChips = this.options.filter((chip) => chip.disabled === false);
    return activeChips;
  }
}
